import { render, staticRenderFns } from "./CircularLoader.vue?vue&type=template&id=700420b6&"
import script from "./CircularLoader.vue?vue&type=script&lang=ts&"
export * from "./CircularLoader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports